import "../css/edit/editdoc.css"
import { useContext, useState } from "react"
import { Dimcontext } from "../../context/pagecontext"
import { Button } from "react-bootstrap"
import { MdClose } from "react-icons/md"

export const CopyMsg = ({ set_msg, content }) => {
    const { setDim } = useContext(Dimcontext)
    const [copied, setCopied] = useState(false);

    const handlemsgclose = () => {
        set_msg(false)
        setDim(false)
        setCopied(false)
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(content);
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
            handlemsgclose(); // Close after showing success state
        }, 1200); 
    }

    return (
        <div className="copymsg-container shadow-lg">
            {/* Header */}
            <div className="msg-header d-flex justify-content-between align-items-center">
                <h6 className="m-0 fw-bold text-secondary text-uppercase ls-1">Message Preview</h6>
                <button className="btn-close-custom" onClick={handlemsgclose}>
                    <MdClose/>
                </button>
            </div>
            
            {/* Message Content Area */}
            <div className="msg-content-wrapper mt-3">
                <div className="msg-body p-4 bg-white border rounded-3 scroll-y">
                    {content}
                </div>
            </div>

            {/* Actions */}
            <div className="mt-4">
                <Button 
                    variant={copied ? "success" : "primary"} 
                    className="w-100 fw-bold py-3 rounded-3 border-0 transition-all shadow-sm" 
                    style={{ 
                        backgroundColor: copied ? '#28a745' : '#8a2be2',
                        letterSpacing: '0.5px'
                    }}
                    onClick={handleCopy}
                >
                    {copied ? (
                        <><i className="bi bi-check-circle-fill me-2"></i> Copied!</>
                    ) : (
                        <><i className="bi bi-clipboard2-check me-2"></i> Copy Message</>
                    )}
                </Button>
            </div>
        </div>
    )
}